module.exports = __webpack_public_path__ + "static/media/user.ca96254a.svg";